import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import { GetReferralCodeResponseType } from '../../../services/PaymentServices/APIService/types';

import usePaymentServices from '../usePaymentServices';

const useGetReferralCode = (): {
  getReferralCodeApi: UseMutateAsyncFunction<
    GetReferralCodeResponseType,
    unknown,
    {
      productCode: string;
    },
    unknown
  >;
  error: string;
  status: MutationStatus;
} => {
  const { paymentServices } = usePaymentServices();

  const getReferralCode = ({ productCode }: { productCode: string }) => {
    return paymentServices.getReferralCode({
      productCode
    });
  };

  const { mutateAsync, error, status } = useMutation(getReferralCode, {
    mutationKey: ['getReferralCodeApi']
  });

  const getReferralCodeApi = mutateAsync;

  return {
    getReferralCodeApi,
    error: error ? getAPIErrorMessage(error) : '',
    status
  };
};

export { useGetReferralCode };
